import { defineMessages } from "react-intl";

export const messages = defineMessages({
  filter: {
    id: "ari.management.sortAndFilter.filter",
    defaultMessage: "Filter",
  },
});
